import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Home from "./app/Home";
import Navbar from "./components/Navbar";
import Contact from "./app/Contact";
import { makeStyles } from "@mui/styles";
import { font } from "./helpers/font";
import Strip from "./components/Strip";
import Reservation from "./app/Reservation";
import { Colors } from "./helpers/Colors";
import Employee from "./app/Employee";
import Room from "./app/Room";
import Login from "./app/Login";
import { BsGoogle } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { clearToken, setToken } from "./redux/Features/Token/TokenSlice";
import MyReservations from "./app/MyReservations";
import MyCabins from "./app/MyCabins";
import { Toaster } from "react-hot-toast";
import AllReservations from "./app/AllReservations";
import { hideSidebar } from "./redux/Features/Sidebar/SidebarSlice";
import UnderMaintanence from "./app/UnderMaintenance";
import UnderMaintenance from "./app/UnderMaintenance";

// import { registerLicense } from '@syncfusion/ej2-base';

// Importing the Style sheet to the Application - @syncfusion/ej2-react-calendars
// import "../node_modules/@syncfusion/ej2-base/styles/material.css";
// import "../node_modules/@syncfusion/ej2-buttons/styles/material.css";
// import "../node_modules/@syncfusion/ej2-react-calendars/styles/material.css";

// Registering Syncfusion license key
// registerLicense('License Key');

const useStyles = makeStyles({
  App: {
    fontFamily: font.supreme,
    backgroundColor: Colors.white,
    transition: "ease-in-out",
    // height: "100vh",
    // height: "max-content",
    // maxHeight: "max-content",
    // overflow: "scroll",

    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  Body: {
    // height: "100vh",
  },
});

function App() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const token = useSelector((state) => state.token.value);

  const [user, setUser] = useState(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [triggerUseEffect, setUseEffect] = useState(false);

  const [tokenValue, setTokenValue] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const onLogoutClick = () => {
    dispatch(setToken(null));
    setIsLoggedIn(false);
    localStorage.removeItem("userTest");
    setUser(null);
    setUseEffect(true);
    setShowSidebar(false);
    // dispatch(hideSidebarbar(false));
    // setUser("");
    // setTokenValue("");
    // sessionStorage.removeItem("userObj");
    console.log("Logout Click");
    // console.log(isSuperAdmin);
  };

  useEffect(() => {
    if (user === null) {
      navigate("/", { replace: true });
    }
    // else {
    // navigate("/addCabins");
    // }
    // user ? navigate(window.location.href) : navigate("/", { replace: true });
  }, [user]);
  // console.log("user", user);
  // console.log("Current Location", window.location.href);
  if (user !== null) {
    // Shows only if user is exists
    return (
      <div className={classes.App}>
        {/* <Strip user={user} isSuperAdmin={isSuperAdmin} /> */}
        <Navbar
          token={token}
          user={user}
          isSuperAdmin={isSuperAdmin}
          showSidebar={showSidebar}
          setShowSidebar={setShowSidebar}
          onLogoutClick={onLogoutClick}
        />
        <div className={classes.Body}>
          <Routes>
            <Route path="/auth" element={<Login />} />
            <Route
              path="/"
              element={
                <Home
                  token={token}
                  user={user}
                  setUser={setUser}
                  isLoggedIn={isLoggedIn}
                  setIsLoggedIn={setIsLoggedIn}
                  isSuperAdmin={isSuperAdmin}
                  setIsSuperAdmin={setIsSuperAdmin}
                  onLogoutClick={onLogoutClick}
                  triggerUseEffect={triggerUseEffect}
                  setUseEffect={setUseEffect}
                />
              }
            />
            <Route
              path="/reservation"
              element={
                <Reservation
                  token={token}
                  user={user}
                  isSuperAdmin={isSuperAdmin}
                  setIsSuperAdmin={setIsSuperAdmin}
                  triggerUseEffect={triggerUseEffect}
                  setUseEffect={setUseEffect}
                />
              }
            />
            <Route
              path="/myReservations"
              element={
                <MyReservations
                  token={token}
                  user={user}
                  isSuperAdmin={isSuperAdmin}
                  setIsSuperAdmin={setIsSuperAdmin}
                  triggerUseEffect={triggerUseEffect}
                  setUseEffect={setUseEffect}
                />
              }
            />
            <Route
              path="/allReservations"
              element={
                <AllReservations
                  token={token}
                  user={user}
                  isSuperAdmin={isSuperAdmin}
                  setIsSuperAdmin={setIsSuperAdmin}
                  triggerUseEffect={triggerUseEffect}
                  setUseEffect={setUseEffect}
                />
              }
            />
            <Route path="/addEmployee" element={<Employee />} />
            <Route
              path="/addCabin"
              element={
                <Room
                  triggerUseEffect={triggerUseEffect}
                  setUseEffect={setUseEffect}
                />
              }
            />
            <Route
              path="/myCabins"
              element={
                <MyCabins
                  triggerUseEffect={triggerUseEffect}
                  setUseEffect={setUseEffect}
                />
              }
            />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>
      </div>
    );
  } else {
    return (
      <div className={classes.App}>
        {/* <Toaster /> */}
        {/* <Strip user={user} isSuperAdmin={isSuperAdmin} /> */}
        <Navbar
          token={token}
          user={user}
          showSidebar={showSidebar}
          setShowSidebar={setShowSidebar}
          onLogoutClick={onLogoutClick}
        />
        <>
          <Routes>
            <Route
              path="/"
              element={
                <Home
                  token={token}
                  user={user}
                  setUser={setUser}
                  isLoggedIn={isLoggedIn}
                  setIsLoggedIn={setIsLoggedIn}
                  isSuperAdmin={isSuperAdmin}
                  setIsSuperAdmin={setIsSuperAdmin}
                  triggerUseEffect={triggerUseEffect}
                  setUseEffect={setUseEffect}
                />
              }
            />
            <Route path="/auth" element={<Login />} />
            <Route path="/underMaintenance" element={<UnderMaintenance />} />
            {/* <Route
              path="/reservation"
              element={
                <Reservation
                  token={token}
                  user={user}
                  isSuperAdmin={isSuperAdmin}
                  setIsSuperAdmin={setIsSuperAdmin}
                  triggerUseEffect={triggerUseEffect}
                  setUseEffect={setUseEffect}
                />
              }
            /> */}
          </Routes>
        </>
      </div>
    );
  }
}

export default App;
